import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  InstitutionProgram,
  ProgramsForInstitutionOptions
} from '@cpd-app/core-module/models';

export const institutionProgramFeatureKey = 'institutionProgram';

export interface InstitutionProgramState
  extends EntityState<InstitutionProgram> {
  error: any;
  programsForInstitutionOptions: ProgramsForInstitutionOptions;
}

export const institutionProgramStateAdapter: EntityAdapter<InstitutionProgram> =
  createEntityAdapter<InstitutionProgram>({
    selectId: (institutionProgram: InstitutionProgram) =>
      institutionProgram.schoolProgramId +
      '_' +
      institutionProgram.schoolProgramEdLevelId,
    sortComparer: false
  });

export const initialInstitutionProgramState: InstitutionProgramState =
  institutionProgramStateAdapter.getInitialState({
    error: null,
    programsForInstitutionOptions: {
      cipCodeCutoff: 7
    }
  });

export const { selectIds, selectEntities, selectAll, selectTotal } =
  institutionProgramStateAdapter.getSelectors();
